import { split } from "lodash";
import BaseClass from "./BaseClass";
import Helper from "./Helper";

const defaultOptions = {};

export default class Counter extends BaseClass {

    constructor(options) {
        super(options, defaultOptions);
        this.init();
    }
    init() {
        var classInstance = this;
        $(document).on('click', '[data-quantity="plus-counter"]', function (e) {
            e.preventDefault();
            var fieldName = $(this).attr('data-field');

            // Parent is wrapper for one room with its adults + children
            var $parent = $(this).closest('.plus-minus-wrapper');
            var elemInput = $parent.find($('input[name=' + fieldName + ']'));

            // Current value is value of the element
            var currentVal = parseInt(elemInput.val());
            var newVal = currentVal + 1;

            if(fieldName == 'avalMedicalTreatment') {
                classInstance.setMedicalTreatmentsPrice(elemInput,newVal);
            }

            if (!isNaN(currentVal)) {
                $parent.find('input[name=' + fieldName + ']').val(newVal);
            } else {
                $parent.find('input[name=' + fieldName + ']').val(0);
            }
        });

        $(document).on('click', '[data-quantity="minus-counter"]', function (e) {
            e.preventDefault();
            var fieldName = $(this).attr('data-field');

            // Parent is wrapper for one room with its adults + children
            var $parent = $(this).closest('.plus-minus-wrapper');
            var elemInput = $parent.find($('input[name=' + fieldName + ']'));

            // Current value is value of the element
            var currentVal = parseInt(elemInput.val());
            var newVal = currentVal - 1;

            if(fieldName == 'avalMedicalTreatment') {
                classInstance.setMedicalTreatmentsPrice(elemInput,newVal);
            }

            if (!isNaN(currentVal && newVal >= 0)) {

                if (!isNaN(currentVal) && currentVal > 0 && currentVal != 1) {
                    $parent.find('input[name=' + fieldName + ']').val(newVal);
                } else {
                    $parent.find('input[name=' + fieldName + ']').val(1);
                }
            }
        });
    }

     /**
     * This function change price for medical treatments.
     *
     * @param {Element} elemInput get element of input when someone click plus or minus
     * @param quantity value which we get from elementInput.
     */
    setMedicalTreatmentsPrice(elemInput, quantity) {
        if(quantity != 0) {
            var elementId = split(elemInput.attr('id'), '-');
            var MedicalTreatmentType = elementId [1];
            var elementIdNumber = elementId[2];
            var actualPrice = parseFloat($('#actual-price_'+MedicalTreatmentType+elementIdNumber).attr("actual-discounted-price").replace(',','.').replace(' ',''));

            if(actualPrice != 0.00) {
                var discountedPrice = parseFloat($('#discounted-price_'+MedicalTreatmentType+elementIdNumber).attr("default-discounted-price").replace(',','.').replace(' ',''));
                var recalculatedDiscountedPrice = quantity * discountedPrice;
                var finalRecalculatedDiscountedPrice = String(recalculatedDiscountedPrice.toFixed(2)).replace('.',',');
                var recalculatedActualPrice = quantity * actualPrice;
                var finalRecalculatedActualPrice = String(recalculatedActualPrice.toFixed(2)).replace('.',',');

                $('#discounted-price_'+MedicalTreatmentType+elementIdNumber).text($($('[data-currency]')[0]).data('currency') + Helper.thousandsSeparator(finalRecalculatedDiscountedPrice));
                $('#'+elementIdNumber).attr('data-discount', finalRecalculatedActualPrice);
                $('#hidden-discounted_'+MedicalTreatmentType+elementIdNumber).val(finalRecalculatedActualPrice);

                $('#actual-price_'+MedicalTreatmentType+elementIdNumber).text($($('[data-currency]')[0]).data('currency') + Helper.thousandsSeparator(finalRecalculatedActualPrice));
                $('#hidden-price_'+MedicalTreatmentType+elementIdNumber).val(finalRecalculatedDiscountedPrice);
                $('#'+elementIdNumber).attr('data-price',finalRecalculatedActualPrice);
                $('#'+elementIdNumber).attr('data-count',String(quantity));
            }
        }
    }

    SetQuantityToOne(elementInput) {
        elementInput.val(1);
        this.setMedicalTreatmentsPrice(elementInput, 1)

    }
}